import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import toast from 'react-hot-toast';
import '../styles/AddTool.css';

const AddTool = () => {
    const [tool, setTool] = useState({
        tool_name: '',
        tool_model: '',
        tool_location: '',
        tool_category: '',
        imageUrl: '',
        restriction: ''
    });
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Handle form changes
    const handleChange = (e) => {
        setTool({ ...tool, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/tools`, tool, {});
            navigate('/edit-tools');
            toast.success('Tool added successfully!', {
                iconTheme: {
                    primary: '#333',
                    secondary: '#DCB41F',
                },
                style: {
                    backgroundColor: '#333',
                    color: '#DCB41F',
                },
            });
        } catch (err) {
            setError(err.response ? err.response.data.message : 'Error adding tool');
            toast.error('Error adding tool', {
                iconTheme: {
                    primary: '#FFFFFF',
                    secondary: '#E61920',
                },
                style: {
                    backgroundColor: '#E61920',
                    color: '#FFFFFF',
                },
            });
        }
    };

    // Handle form cancel
    const handleCancel = () => {
        navigate('/edit-tools');
        toast('No changes were made.', {
            iconTheme: {
                primary: '#333',
                secondary: '#DCB41F',
            },
            style: {
                backgroundColor: '#333',
                color: '#DCB41F',
            },
        });
    };

    return (
        <div>
            <Header />
            <div className="add-tool-container">
                <h2>Add New Tool</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
    <input type="text" name="tool_name" placeholder="Tool Name" onChange={handleChange} required />
    <input type="text" name="tool_model" placeholder="Tool Model" onChange={handleChange} required />
    <input type="text" name="tool_location" placeholder="Tool Location" onChange={handleChange} required />
    <input type="text" name="tool_category" placeholder="Tool Category" onChange={handleChange} required />
    <input type="text" name="imageUrl" placeholder="Image URL" onChange={handleChange} required />
    
    <select name="restriction" value={tool.restriction} onChange={handleChange} required>
        <option value="">Select Restriction</option>
        <option value="safe">Safe (No supervision needed)</option>
        <option value="cautious">Cautious (Adult supervision needed)</option>
        <option value="danger">Danger (Not allowed)</option>
    </select>

    <div className="button-group">
        <button type="submit">Add Tool</button>
        <button type="button" onClick={handleCancel}>Cancel</button>
    </div>
</form>
            </div>
        </div>
    );
};

export default AddTool;
